import * as z from 'zod'

export const addExclusionSchema = z.object({
  placeGeoid: z.string().min(1, 'Place GEOID is required'),
})

export type AddExclusionSchema = z.infer<typeof addExclusionSchema>
